import React, { useEffect } from 'react'
import '../styles/promoscreen.css'
import ReactPlayer from 'react-player/lazy'

import Nav from '../components/Nav'
import Footer from '../components/Footer'

const PromoScreen = () => {
    const videoUrl = "https://youtu.be/gpQPSIYvb14?si=86auLqjbwneTs4HX";

    // https://youtu.be/gpQPSIYvb14?si=86auLqjbwneTs4HX

    useEffect(() => {
        document.title = `Widows of Cradock 2025`;
    }, []);

    return (
        <>
            <Nav />
            <section className='promoscreen-container'>
                <div className='promo-container'>
                    <ReactPlayer
                        url={videoUrl}
                        controls={true}
                        width="100%"
                        height="100%"
                        playing={false}        
                        loop={true}           
                        muted={false}    
                        lazy={true}      
                    />
                </div>
            </section>
            <Footer />
        </>
    )
}

export default PromoScreen